import FJConstant from '../constants/FJConstant';
import FJLocalStore from '../store/FJLocalStore';

const FJ_ERROR_MESSAGE_KEY_MAP = {
    [FJConstant.VIOLATION]: 'generation-failed-due-to-potential-content-violations-please-click-retry',
};

const FJErrorMessageUtil = {
    getErrorMessageByState(state) {
        const key = FJ_ERROR_MESSAGE_KEY_MAP[state];
        return key ? FJLocalStore._(key) : null;
    },
};

export default FJErrorMessageUtil;
